import { Box, Icon, IconButton, Typography } from "@mui/material";
import TicketUpsale from "../../../types/TicketUpsale";
import { modalShow } from "app/App/actions";
import { useDispatch, useSelector } from "react-redux";

type UpsaleProps = {
    minQuantity?: number;
    onChange: (quantity: number) => void;
    quantity: number;
    upsale: TicketUpsale;
};

const Upsale = ({
    upsale,
    minQuantity = 0,
    quantity,
    onChange,
}: UpsaleProps) => {
    const dispatch = useDispatch();
    const { "general-currency": currency } = useSelector(
        (state: any) => state.web.settings.location_settings,
    );

    const handleImageUpsale = (
        e: React.MouseEvent,
        id: number,
        image: string,
    ) => {
        e.preventDefault();
        dispatch(modalShow("UpsaleImageModal", { id, image }));
    };

    const handleUpsaleAddQuantity = (id: number) => {
        onChange(quantity + 1);
    };

    const handleUpsaleRemoveQuantity = (id: number) => {
        if (quantity <= minQuantity) {
            return;
        }

        onChange(quantity - 1);
    };

    const renderQuantity = () => {
        return (
            <Box
                onClick={(event) => {
                    event.stopPropagation();
                    event.preventDefault();
                }}
            >
                <Box display="flex" justifyContent="start" alignItems="center">
                    <IconButton
                        onClick={() => handleUpsaleRemoveQuantity(upsale.id)}
                        sx={{
                            ":hover": {
                                boxShadow: "none",
                            },
                            width: { xs: 24, tablet: 28 },
                            height: { xs: 24, tablet: 28 },
                            "&.Mui-disabled": {
                                backgroundColor: "rgb(185 121 100 / 0.26)",
                            },
                        }}
                    >
                        <Icon sx={{ fontSize: { xs: 16, tablet: 18 } }}>
                            remove
                        </Icon>
                    </IconButton>
                    <Typography
                        sx={{
                            fontSize: 14,
                            fontWeight: 500,
                            px: 2,
                            fontFamily: "'Noto Sans', sans-serif",
                            color: {
                                xs: "#495366",
                                tablet: "#02263A",
                            },
                            width: "auto !important",
                            minWidth: 55,
                            textAlign: "center",
                        }}
                    >
                        {quantity}
                    </Typography>

                    <IconButton
                        onClick={() => handleUpsaleAddQuantity(upsale.id)}
                        sx={{
                            ":hover": {
                                boxShadow: "none",
                            },
                            width: { xs: 24, tablet: 28 },
                            height: { xs: 24, tablet: 28 },
                            "&.Mui-disabled": {
                                backgroundColor: "rgb(185 121 100 / 0.26)",
                            },
                        }}
                    >
                        <Icon sx={{ fontSize: { xs: 16, tablet: 18 } }}>
                            add
                        </Icon>
                    </IconButton>
                </Box>
            </Box>
        );
    };

    return (
        <Box
            key={upsale.id}
            p={1.5}
            border={1}
            borderColor="grey.200"
            borderRadius={2}
            display="flex"
            gap={2}
        >
            {upsale.image && (
                <Box
                    component="img"
                    src={upsale.image}
                    alt={`upsale-${upsale.id}`}
                    height={46}
                    width={46}
                    sx={{
                        alignSelf: "flex-start",
                        cursor: "pointer",
                        objectFit: "contain",
                    }}
                    onClick={(e) =>
                        handleImageUpsale(e, upsale.id, upsale.image as string)
                    }
                />
            )}
            <Box display="flex" flexDirection="column" flex={1}>
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    flex={1}
                >
                    <Typography sx={{ fontSize: 16 }}>
                        {upsale.subtranslations.name.lang_en}
                    </Typography>
                    <Typography sx={{ fontSize: 16 }}>
                        {upsale.price.price(currency, "left")}
                    </Typography>
                </Box>
                {renderQuantity()}
            </Box>
        </Box>
    );
};

export default Upsale;
